import { Grid } from "@mui/material";
import MDInput from "components/Basics/MDInput";

const InputColor = ({ label, value, onChange, disabled, error, InputProps = {}, ...rest }) => {
	return (
		<Grid
			size="grow"
			sx={{
				flexBasis: "16.666%",
				minWidth: "16.666%"
			}}
		>
			<MDInput
				disabled={disabled}
				error={error}
				className="dialogInput"
				label={label}
				value={value || ""}
				onChange={e => onChange(e.target.value)}
				type="color"
				slotProps={{
					input: {
						style: { width: "100%", height: "100%" }
					}
				}}
				style={{ height: "100%", width: "100%" }}
				{...InputProps}
				{...rest}
			/>
		</Grid>
	);
};

export default InputColor;
